import type { ReactNode } from 'react';

import { useTheme } from '@mui/material/styles';

import { Box } from '../../../Box';
import { CircularProgress } from '../../../CircularProgress';
import { Typography } from '../../../Typography';
import { FillBanner } from '../FillBanner';

interface FileInputPreviewLoadingProps {
  height: number;
  hasValue: boolean;
  isDesktop: boolean;
  autorecognitionQr: boolean;
  bannerText?: string;
  loadingText?: ReactNode;
}

export const FileInputPreviewLoading = ({
  height,
  hasValue,
  isDesktop,
  autorecognitionQr,
  bannerText,
  loadingText,
}: FileInputPreviewLoadingProps) => {
  const theme = useTheme();

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      width="100%"
      height={418}
      bgcolor="bg.light.primary"
      border={`${theme.tokens.border.m}px dashed`}
      borderColor="stroke.primary"
      radius="l"
    >
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height={height}
      >
        {bannerText && !hasValue && <FillBanner>{bannerText}</FillBanner>}
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          width={{ xs: 250 }}
          mt={!isDesktop && bannerText && !hasValue ? '8' : '0'}
          gap="8"
        >
          <CircularProgress size={20} />
          {loadingText || (
            <Box
              mb={{ xs: '0', md: '12' }}
              color={
                isDesktop || autorecognitionQr
                  ? 'text.light.tertirary'
                  : 'original.brand.primary'
              }
            >
              <Typography
                display="block"
                variant={isDesktop || autorecognitionQr ? 'body2' : 'caption'}
                color="inherit"
                align="center"
              >
                Пожалуйста, подождите
              </Typography>
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
};
